
// 模拟网络延迟
const delay = (ms = 500) => new Promise(resolve => setTimeout(resolve, ms));

// 创建响应数据
const createResponse = (data, message = 'success') => ({
    traceId: `mock-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
    success: true,
    msg: null,
    errorCode: null,
    errorMessage: null,
    flag: 'success',
    code: null,
    message: null,
    data
});

const createPageResponse = (data, paging, message = 'success') => ({
    traceId: `mock-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
    success: true,
    msg: null,
    errorCode: null,
    errorMessage: null,
    flag: 'success',
    code: null,
    message: null,
    data: {
        tableData: data,
        paging: paging
    }
});

// 创建错误响应
const createErrorResponse = (message, errorCode = 'ERROR') => ({
    traceId: `mock-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
    success: false,
    msg: null,
    errorCode,
    errorMessage: message,
    flag: 'fail',
    code: null,
    message: null,
    data: null
});

class MockDataUtil {
    async mockRes(data) {
        return createResponse(data);
    }

    async mockCreateErrorRes(message, errorCode) {
        return createErrorResponse(message, errorCode);
    }

    async mockPageRes(data, paging) {
        return createPageResponse(data, paging)
    }
}

export const mockDataUtil = new MockDataUtil();